import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=9c678ca2&scoped=true&lang=html"
import script from "./checklist.vue?vue&type=script&lang=js"
export * from "./checklist.vue?vue&type=script&lang=js"
import style0 from "./checklist.vue?vue&type=style&index=0&id=9c678ca2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c678ca2",
  null
  
)

export default component.exports